import styled from 'styled-components';
import { ApButtonTab, colors } from '@alixpartners/ui-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 8px 24px 0;
  background-color: ${colors.white};
  align-items: center;
  box-shadow: inset 0px -1px 0px 0px #999999;
  box-sizing: border-box;
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
`;

interface ISelectedState {
  isSelected: boolean;
}

export const ButtonTab = styled(ApButtonTab)<ISelectedState>`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: ${({ isSelected }) => (isSelected ? 700 : 500)};
  font-size: 14px;
  line-height: 19px;
  text-transform: uppercase;
  padding: 8px 18px;
  color: ${({ isSelected }) => (isSelected ? '#3f7b25' : '#4a4a4a')};
  border-bottom: 3px solid
    ${({ isSelected }) => (isSelected ? '#3f7b25' : 'transparent')};
  transition: none;
`;
